// ============================================================================
// JARVISTRAVEL - PLAN PRICE
// A plan card's price, rendered one way on every card that shows one: the
// onboarding PlanGate, the Paywall and Plan & billing (JAR-3179). The words
// come from planCardPrice; this owns how they read, so a struck price is said
// the same everywhere, to the eye and to a screen reader.
// ============================================================================

import { planCardPrice, type SubscriptionPlan } from '@/app/api/payments';

interface PlanPriceProps {
  plan: SubscriptionPlan;
  /** The size of the line the card leads with, which differs by surface. */
  leadClassName: string;
}

export function PlanPrice({ plan, leadClassName }: PlanPriceProps) {
  const { regular, lead, renewal } = planCardPrice(plan);
  return (
    <div className="mt-1">
      {/* A strike-through is not announced, so the struck amount is named:
          a screen reader hears "Regular price $99 / year", not a bare number
          beside the price that replaces it. */}
      {regular && (
        <p className="text-sm text-muted tabular-nums">
          <span className="sr-only">Regular price </span>
          <s>{regular}</s>
        </p>
      )}
      <p className={leadClassName}>{lead}</p>
      {renewal && <p className="text-sm text-muted tabular-nums">{renewal}</p>}
    </div>
  );
}
